import { render, staticRenderFns } from "./ReviewExerciseNew.vue?vue&type=template&id=4995c2cf"
import script from "./ReviewExerciseNew.vue?vue&type=script&lang=js"
export * from "./ReviewExerciseNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports